import { render, staticRenderFns } from "./ResultsPersonas.vue?vue&type=template&id=dc1de7ea&"
import script from "./ResultsPersonas.vue?vue&type=script&lang=js&"
export * from "./ResultsPersonas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports